export default {
  user: null,
  authChecking: false
};
